import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()((theme) => ({
  autoGrowInput: {
    minWidth: theme.spacing(1),
    width: 'fit-content',
    padding: theme.spacing(1),
    margin: theme.spacing(1),
    borderRadius: 12,
    borderStyle: 'solid',
    borderWidth: 2,
    borderColor: theme.palette.divider,
    outline: 'none',
    '&:focus, &:hover': {
      borderColor: theme.palette.primary.main,
    },
  },
  singleLine: {
    // single line
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    '& br': {
      display: 'none',
    },
  },
}));
//todo delete once we phase out legacy notifications
const QInputSpan = (props) => {
  const { classes, cx } = useStyles();
  const { defaultValue, onChange, multiline, autoFocus, numbersOnly, ...otherProps } = props;
  const elementRef = useRef();
  const [value, setValue] = useState(defaultValue);
  useEffect(() => {
    if (elementRef.current && value === defaultValue) {
      elementRef.current.textContent = defaultValue;
      if (autoFocus) {
        elementRef.current.focus();
      }
    }
  }, [value, defaultValue, autoFocus]);

  const keyDown = (e) => {
    const keyNum = e.keyCode || e.which;
    switch (keyNum) {
      case 8: // backspace
      case 37: // up
      case 38: // left
      case 39: // right
      case 40: // down
        break;
      case 13: // enter
        elementRef.current.blur();
        break;
      case 27: // escape
        elementRef.current.blur();
        break;
      case 65: // a
      case 67: // c
      default:
        if (e.target.textContent.length >= 6) {
          e.preventDefault();
        }
        if (numbersOnly && '0123456789'.indexOf(e.key) === -1) {
          e.preventDefault();
        }
        break;
    }
  };
  return (
    <span
      aria-label='Input Span'
      className={cx(...[classes.autoGrowInput, ...(multiline ? [] : [classes.singleLine])])}
      sharedcomponentid={'Q_INPUT_SPAN'}
      role='textbox'
      contentEditable
      tabIndex={0}
      ref={elementRef}
      onKeyDown={keyDown}
      onInput={(event) => {
        setValue(event.target.textContent);
        onChange?.(event.target.textContent);
      }}
      onPaste={(e) => e.preventDefault()}
      onFocus={(event) => {
        let sel;
        let range;
        if (window.getSelection && document.createRange) {
          range = document.createRange();
          range.selectNodeContents(event.currentTarget);
          sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
        } else if (document.body.createTextRange) {
          range = document.body.createTextRange();
          range.moveToElementText(event.currentTarget);
          range.select();
        }
      }}
      {...otherProps}
    />
  );
};
QInputSpan.propTypes = {
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
  autoFocus: PropTypes.bool,
  multiline: PropTypes.bool,
  numbersOnly: PropTypes.bool,
};

export default QInputSpan;
